import PropTypes from "prop-types";
import React from "react";

import { Separator } from "@swa-ui/core";
import { TextContent } from "@swa-ui/placements";

import styles from "./ShowTheMath.module.scss";

export const ShowTheMath = (props) => {
  const { offerTotal = "0", showTheMath = {}, redeemablePoints, userLoggedIn } = props;
  const { background = {}, credit, currentBalance, lineSeparator, total } = showTheMath;
  const { color: backgroundColor } = background;
  const totalEstimatedPoints = redeemablePoints ? getTotalEstimatedPoints() : offerTotal;

  return userLoggedIn ? (
    <div className={styles.showTheMathContainer} style={{ backgroundColor }}>
      {currentBalance && renderShowTheMathRow(currentBalance.label, currentBalance.value)}
      {credit && renderShowTheMathRow(credit.label, credit.value)}
      <div className={styles.lineSeparator}>
        <Separator {...getSeparatorProps()} />
      </div>
      {total && renderShowTheMathRow(total.label, total.value)}
    </div>
  ) : null;

  function renderShowTheMathRow(label, value) {
    return (
      <>
        <div className={styles.label}>{renderText(label)}</div>
        <div className={styles.value}>{renderText(value)}</div>
      </>
    );
  }

  function renderText(textTypeObject) {
    const value = replacePlaceholders(textTypeObject?.value);

    return value && <TextContent {...textTypeObject} value={value} />;
  }

  function getSeparatorProps() {
    const { color, fontWeight: weight = "small" } = lineSeparator || {};

    return {
      color,
      weight,
    };
  }

  function replacePlaceholders(template) {
    const templateData = {
      offerTotal,
      redeemablePoints,
      totalEstimatedPoints,
    };

    return template.replace(/\$\{(.*?)\}/g, (match, key) =>
      key in templateData ? templateData[key]?.toLocaleString() : match
    );
  }

  function getTotalEstimatedPoints() {
    return (
      parseInt(redeemablePoints.toString().replace(/,/g, "")) +
      parseInt(offerTotal.toString().replace(/,/g, ""))
    );
  }
};

ShowTheMath.displayName = "ShowTheMath";
ShowTheMath.propTypes = {
  /** String that contains offer total points defined by wcm */
  offerTotal: PropTypes.string,
  redeemablePoints: PropTypes.string,
  /** Object that contains props including backgroundColor, credit, currentBalance and total */
  showTheMath: PropTypes.shape({
    /** Background color to be used */
    background: PropTypes.shape({
      color: PropTypes.string,
    }),
    /** Object that contains credit row */
    credit: PropTypes.shape({
      /** Label to be used for credit line item */
      label: PropTypes.shape({
        value: PropTypes.string.isRequired,
      }),
      /** Value to be used for credit line item */
      value: PropTypes.shape({
        value: PropTypes.string.isRequired,
      }),
    }).isRequired,
    /** Object that contains current balance row */
    currentBalance: PropTypes.shape({
      /** Label to be used for current balance line item */
      label: PropTypes.shape({
        value: PropTypes.string.isRequired,
      }),
      /** Value to be used for current balance line item */
      value: PropTypes.shape({
        value: PropTypes.string.isRequired,
      }),
    }).isRequired,
    /** Object that props for separator line color and weight */
    lineSeparator: PropTypes.shape({
      color: PropTypes.string.isRequired,
      fontWeight: PropTypes.string.isRequired,
    }),
    /** Object that contains total row */
    total: PropTypes.shape({
      /** Label to be used for total line item */
      label: PropTypes.shape({
        value: PropTypes.string.isRequired,
      }),
      /** Value to be used for total line item */
      value: PropTypes.shape({
        value: PropTypes.string.isRequired,
      }),
    }).isRequired,
  }),
  userLoggedIn: PropTypes.bool,
};
